import { jsPDF } from "jspdf";

import {FontOswald} from './fonts/oswald';
import {FontRobotoRegular} from './fonts/roboto-regular';
import {FontRobotoBold} from './fonts/roboto-bold';

import {OcLogo} from './images/oc-logo';

const LogoFontSize = 15;
const NiceRoofFontSize = 22;

const StatTitleFontSize = 11;
const StatContentFontSize = 19;

const HeadingFontSize = 21;
const ContentFontSize = 13;

const LeftGutter = 10;
const RightGutter = 209 - LeftGutter;

const LeftColumnWidth = 84;

const SummaryItemStart = 112;
const SummaryItemHeight = 18;
const SummaryItemTitleFontSize = 14;

const LineColor = 200;
const FooterStart = 240;
const FooterCopyFontSize = 10;

const FooterLinkURL = "https://www.owenscorning.com/roofing/warranty/";

const ModelWidth = 100;

const readCopy = (id) => {
  return document.getElementById(`summary-pdf-${id}`)?.textContent;
};

export default class SummaryPDF {
  header(doc) {
    // Summary page from contractor products link does not have a logo
    const logoText = readCopy('logo-text');
    if (!logoText) {
      return;
    }

    doc.addImage(OcLogo, 'JPEG', LeftGutter, 15, 14, 14);

    doc.setFont(FontOswald.family);
    doc.setFontSize(LogoFontSize);
    doc.text(logoText.toUpperCase(), 27, 22, { lineHeightFactor: 1.02, maxWidth: 40 });

    [
      {
        title: readCopy('warranty-header').toUpperCase(),
        value: readCopy('warranty-result').toUpperCase(),
        x: 146
      },
      {
        title: readCopy('wind-header').toUpperCase(),
        value: readCopy('wind-result').toUpperCase(),
        x: 104
      }
    ].forEach((stat) => {
      doc.setFont(FontRobotoRegular.family);
      doc.setFontSize(StatTitleFontSize);

      doc.text(stat.title, stat.x, 19.5);

      doc.setFont(FontOswald.family);
      doc.setFontSize(StatContentFontSize);

      doc.text(stat.value, stat.x, 28);
    });
  }

  introduction(doc) {
    doc.setFont(FontOswald.family);
    doc.setFontSize(NiceRoofFontSize);

    doc.text(readCopy('intro-header').toUpperCase(), LeftGutter, 44);

    doc.setFont(FontRobotoRegular.family);
    doc.setFontSize(ContentFontSize);

    doc.text(
      readCopy('intro-copy'),
      LeftGutter, 54,
      {
        maxWidth: LeftColumnWidth,
        lineHeightFactor: 1.2
      }
    );
  }

  details(doc) {
    doc.setFont(FontOswald.family);
    doc.setFontSize(HeadingFontSize);

    doc.text(readCopy('summary-header').toUpperCase(), LeftGutter, 102);

    Array.from(document.querySelectorAll('.summaryDetails li')).forEach((item, index) => {
      let title = item.querySelector('.stepSummaryHeading').textContent;
      let value = item.querySelector('.stepSummaryValue').textContent;

      let y = SummaryItemStart + (SummaryItemHeight * index);

      doc.setFontSize(SummaryItemTitleFontSize);
      doc.setFont(FontRobotoBold.family);
      doc.text(title, LeftGutter, y);

      y += 2.5;
      doc.setDrawColor(LineColor);
      doc.line(LeftGutter, y, LeftGutter + LeftColumnWidth, y);

      y += 6;
      doc.setFontSize(ContentFontSize);
      doc.setFont(FontRobotoRegular.family);
      doc.text(value, LeftGutter, y);
    });
  }

  model(doc) {
    let canvas = document.getElementById('bar');
    doc.addImage(canvas.toDataURL('image/png'), 'PNG', RightGutter - ModelWidth, 40, ModelWidth, ModelWidth * (canvas.height / canvas.width), "model", "FAST");
  }

  footer(doc) {
    doc.setFontSize(FooterCopyFontSize);
    doc.setFont(FontRobotoRegular.family);

    doc.line(LeftGutter, FooterStart, RightGutter, FooterStart);

    let disclaimer = $('#summary-pdf-disclaimer-1').clone();
    let disclaimerLink = disclaimer.find('a');

    doc.text(disclaimer.text().trim(), LeftGutter, FooterStart + 10);

    let linkX = LeftGutter + 2.3;
    let linkY = FooterStart + 9.9;
    let linkW = doc.getTextWidth(disclaimerLink.text());
    doc.link(linkX, linkY - 2.75, linkW, 3.5, { url: new URL(disclaimerLink.attr('href'), document.baseURI).href });

    doc.setDrawColor(0);
    doc.line(linkX, linkY + 0.5, linkX + linkW, linkY + 0.5);

    doc.text(readCopy('disclaimer-2'), LeftGutter, FooterStart + 17, { maxWidth: RightGutter - LeftGutter });

    let copyrightMGM = $('.copyright-statement').clone();
    let copyrightOC = copyrightMGM.find('a').text();
    copyrightMGM.find('a').remove();

    doc.text(copyrightOC.trim(), LeftGutter, FooterStart + 29, { maxWidth: RightGutter - LeftGutter });
    doc.text(copyrightMGM.text().trim(), LeftGutter, FooterStart + 37, { maxWidth: RightGutter - LeftGutter });
  }

  generate(filename) {
    let doc = new jsPDF();

    [FontOswald, FontRobotoRegular, FontRobotoBold].forEach((font) => {
      doc.addFileToVFS(font.filename, font.data);
      doc.addFont(font.filename, font.family, font.weight);
    });

    this.header(doc);
    this.introduction(doc);
    this.details(doc);
    this.model(doc);
    this.footer(doc);

    doc.save(filename);
  }
}
